import { render, staticRenderFns } from "./PromoCode.vue?vue&type=template&id=5e5880a5&scoped=true&"
import script from "./PromoCode.vue?vue&type=script&lang=js&"
export * from "./PromoCode.vue?vue&type=script&lang=js&"
import style0 from "./PromoCode.vue?vue&type=style&index=0&id=5e5880a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5880a5",
  null
  
)

export default component.exports